import Link from "next/link";
import { ArrowLeft } from "lucide-react";

import { cn } from "@/lib/utils";

const BASE_CLASS =
  "inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground";

type HrefProps = {
  href: string;
  onClick?: never;
};

type ButtonProps = {
  href?: never;
  onClick: () => void;
};

type Props = (HrefProps | ButtonProps) & {
  children: React.ReactNode;
  className?: string;
};

export function BackLink({ href, onClick, className, children }: Props) {
  const classes = cn(BASE_CLASS, className ?? "mb-4");
  const content = (
    <>
      <ArrowLeft className="h-4 w-4" />
      {children}
    </>
  );

  if (href) {
    return (
      <Link href={href} className={classes}>
        {content}
      </Link>
    );
  }

  return (
    <button type="button" onClick={onClick} className={classes}>
      {content}
    </button>
  );
}
